<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="repasSvc"></yo-generic-datagrid-pn>
